export const baseUrl_api = "https://app.aimindwork.com/meeting/api";
export const baseUrl = "https://app.aimindwork.com/meeting";

// export const baseUrl_api = "https://chattest.com/chat/api";
// export const baseUrl = "https://chattest.aimindwork.com/chat";

export const apiUrl_api = "https://app.aimindwork.com/api";
export const apiUrl = "https://app.aimindwork.com";

